import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetResolvedAlertsRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetResolvedAlertsResponseDtoSchema = z.object({
  resolvedAlerts: z.object({
    count: z.number().nullable().optional(),
    currentPct: z.number().nullable().optional(),
    changePct: z.number().nullable(),
  }),
  sparkline: z.object({
    granularity: z.string(),
    points: z.array(
      z.object({
        start: z.string(),
        end: z.string(),
        value: z.number().nullable(),
      })
    ),
  }),
});

export type GetResolvedAlertsRequestDto = z.infer<
  typeof _GetResolvedAlertsRequestDtoSchema
>;
export type GetResolvedAlertsResponseDto = z.infer<
  typeof GetResolvedAlertsResponseDtoSchema
>;

export const getResolvedAlerts = (
  params: GetResolvedAlertsRequestDto,
  config?: AxiosRequestConfig<GetResolvedAlertsRequestDto>
) =>
  api
    .get('/facilities/resolved-alerts', { params, ...config })
    .then(responseContract(GetResolvedAlertsResponseDtoSchema));
